module.exports = __webpack_public_path__ + "img/btn_Live.528efee8.png";